import { signInResetPasswordFormStyles } from "@insite/content-library/Widgets/SignIn/SignInResetPasswordForm";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

signInResetPasswordFormStyles.descriptionText = {
    css: css`
        font-family: ${TYPOGRAPHY.fontFamily.title};
        font-style: normal;
        font-weight: ${TYPOGRAPHY.weight.base} !important;
        font-size: ${TYPOGRAPHY.size.smaller};
        line-height: ${TYPOGRAPHY.lineHeight.base};
        color: ${getColor("text.accent")} !important;
    `,
}

signInResetPasswordFormStyles.userNameTextField = {
    css: css`
        font-family: ${TYPOGRAPHY.fontFamily.title} !important;
        font-style: normal;
        font-weight: ${TYPOGRAPHY.weight.base} !important;
        font-size: ${TYPOGRAPHY.size.small} !important;
        line-height: ${TYPOGRAPHY.lineHeight.xbase};
        color: ${getColor("text.accent")} !important;
    `,
}

signInResetPasswordFormStyles.userNameGridItem = {
    css: css`
        flex-basis: 100% !important;
        max-width: 100% !important;
        > div[class^="FormFieldStyle"] > label {
            font-family: ${TYPOGRAPHY.fontFamily.title} !important;
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.bold} !important;
            font-size: ${TYPOGRAPHY.size.smaller} !important;
            line-height: ${TYPOGRAPHY.lineHeight.base};
            color: ${getColor("text.main")} !important;
        }
    `,
}

signInResetPasswordFormStyles.buttonsGridItem = {
    css: css`
        display: flex;
        justify-content: space-between;
        flex-basis: 100%;
        max-width: 100%;
    `,
}

signInResetPasswordFormStyles.cancelButton = {
    css: css`
        border-radius: 0px;
        min-height: 44px !important;
        background: ${getColor("primary")};
        > span {
            font-family: ${TYPOGRAPHY.fontFamily.title} !important;
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.bold} !important;
            font-size: ${TYPOGRAPHY.size.base} !important;
            line-height: ${TYPOGRAPHY.lineHeight.xbase};
            color: ${getColor("primary.contrast")} !important;
        }
    `,
}

signInResetPasswordFormStyles.sendButton = {
    css: css`
        border-radius: 0px;
        min-height: 44px !important;
        background: ${getColor("primary")};
        > span {
            font-family: ${TYPOGRAPHY.fontFamily.title} !important;
            font-style: normal;
            font-weight: ${TYPOGRAPHY.weight.bold} !important;
            font-size: ${TYPOGRAPHY.size.base} !important;
            line-height: ${TYPOGRAPHY.lineHeight.xbase};
            color: ${getColor("primary.contrast")} !important;
        }
    `,
}